import { Component } from '@angular/core';
import { LanguageService } from '@services';

@Component({
  selector: 'app-businesslayout',
  templateUrl: './businesslayout.component.html',
  styleUrl: './businesslayout.component.scss',
})
export class BusinesslayoutComponent {
  constructor(private _languageService: LanguageService) {}

  ngOnInit() {
    this._languageService.setLanguageForBusinessPortal();
  }
}
